import refs from '../helpers/refs'

class MSlideOutRetailer {
  constructor (slideOutRetailer) {
    this.slideOutRetailer = slideOutRetailer
    this.$refs = refs(this.slideOutRetailer)
    this.showing = false

    this.init()
  }

  init () {
    // Close button
    this.$refs.closeRetailers.addEventListener('click', this.hide.bind(this))

    // Event handlers
    document.addEventListener('retailers:show', this.show.bind(this))
    document.addEventListener('retailers:hide', this.hide.bind(this))
    document.addEventListener('retailers:toggle', this.toggle.bind(this))
  }

  show () {
    this.showing = true
    this.slideOutRetailer.classList.remove('hidden')
  }

  hide () {
    this.showing = false
    this.slideOutRetailer.classList.add('hidden')
  }

  toggle () {
    if (this.showing) {
      this.hide()
    } else {
      this.show()
    }
  }
}

// On DOM Content Loaded
document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-m-slide-out-retailer]')
    .forEach(el => new MSlideOutRetailer(el))
})
